import React from "react";

export default function DevBuildBanner() {
  if (process.env.REACT_APP_DEPLOY_ENV !== "dev") return null;
  return (
    <div role="status" style={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 2147483647,
      background: "#78350f", color: "#fff", padding: "4px 12px",
      fontSize: 12, textAlign: "center", pointerEvents: "none",
    }}>
      Copresent DEV · {process.env.REACT_APP_BUILD_TICKET || "Test build"} ·{" "}
      {process.env.REACT_APP_BUILD_SHA?.slice(0, 12)}
    </div>
  );
}
